import React from 'react';

// === Components === //
import Container from '@components/common/Container';

// === Types === //
import { Variant } from '@content/types/layout';
import ImageFull from '@components/common/ImageFull';
import ButtonLink from '@components/common/ButtonLink';
import styled from '@emotion/styled';

const PreviewWrapper = styled.div`
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  margin-bottom: 25px;
`;

interface DownloadProps {
  variant: Variant;
  preview: DownloadPreviewData;
  file: string;
  ctaLabel: string;
}

interface DownloadPreviewData {
  url: string;
  alt: string;
}

const Download = ({ variant, preview, file, ctaLabel }: DownloadProps) => {
  return (
    <Container>
      <div>
        <PreviewWrapper>
          <ImageFull imageDesktop={preview.url} alt={preview.alt} />
        </PreviewWrapper>
        <div>
          <ButtonLink type="external" link={file} icon="download" variant={variant}>
            {ctaLabel}
          </ButtonLink>
        </div>
      </div>
    </Container>
  );
};

export default Download;
